import { gql } from 'apollo-boost';

export const SET_MESSAGE_GROUPING_ENABLED = gql`
    mutation($enabled: Boolean!) {
        setMessageGroupingEnabled(enabled: $enabled) {
            id
            messageGroupingEnabled
        }
    }
`;
